import React, { Component } from "react";
import { Input, Button, Divider, Form, List, Skeleton, Tooltip, DatePicker, Select } from "antd";
import moment from 'moment'
import { GetLogData, getAffiliatedHospitelList, GetUserList } from '@/request/api'
import { requestErrorLog } from '@/common/util'
import './components.scss'
import './logManage.scss'
const { Option } = Select;

class SettingDepartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [],//列表数据
      dayLength: 0,
      logDate: moment(new Date()).format('YYYY-MM-DD'),
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
      hosptialList: [],
      userList: [],
      allUserList: [],
      EXAM_UID: '',
    }
  }
  changeHosToDept = (code) => {
    this.props.form.setFieldsValue({ USER_UID: '', });
    this.getUserList(code)
  }
  getUserList = async (HOSPITAL_CODE) => {
    let res = await GetUserList(HOSPITAL_CODE)
    if (res && res.Status === 1) {
      const data = res.Result
      this.setState({
        userList: data,
      })
    } else {
      requestErrorLog('', '日志管理-获取操作人员列表报错', 0, true)
    }
  }
  getAffiliatedHospitelList = () => {
    getAffiliatedHospitelList().then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result
        this.setState({
          hosptialList: data,
        })
      } else {
        requestErrorLog('', '日志管理-获取医院列表报错', 0, true)
      }
    })
  }
  async componentDidMount() {
    //要先把操作人员的信息取出来
    let allUserList = []
    let res = await GetUserList('')
    if (res && res.Status === 1) {
      allUserList = res.Result
      await this.setState({
        allUserList,
      })
    } else {
      requestErrorLog('', '日志管理-获取操作人员列表报错', 0, true)
    }
    this.getAffiliatedHospitelList()
    this.loadMoreData()
    let scrollableDiv = document.getElementById('scrollableDiv');
    const that = this
    scrollableDiv.onwheel = function (event) {
      let EXAM_UID = that.props.form.getFieldValue("EXAM_UID")
      if (EXAM_UID === '') {//查询条件有病例id不做滚动
        if (event.currentTarget.scrollHeight > event.currentTarget.clientHeight) {//有滚动条触底刷新
          // 页面上滚动到底部的条件浏览器缩放导致scrollTop不一定是整数，但是误差在1内
          let a = event.currentTarget.scrollHeight - event.currentTarget.clientHeight - event.currentTarget.scrollTop
          if (-1 < a && a < 1) {
            //超过七天就不加载了
            if (that.state.dayLength < 7) {
              // 页面内已经滚动的距离 = 页面中内容的总高度 - 浏览器可视部分的高度
              that.loadMoreData()
            } else {
              // message.warn('已加载七日数据，如需更多，请重新选择日志时间')
              console.log('已加载七日数据，如需更多，请重新选择日志时间')
            }
          }
        } else {//无滚动条直接刷新
          if (that.state.dayLength < 7) {
            event.deltaY > 0 ? that.loadMoreData() : console.log("鼠标向上滚动");
          }
          else {
            console.log('已加载七日数据，如需更多，请重新选择日志时间')
          }
        }
      }
    }
  }
  loadMoreData = () => {
    if (this.state.loading) {
      return;
    }
    this.setState({
      loading: true
    })
    let USER_UID = this.state.userInfo.USER_UID
    if (USER_UID === 'PLATFORMUSER') {
      USER_UID = this.props.form.getFieldValue("USER_UID");
    }
    let QUERY_DATE = this.props.form.getFieldValue("logTime");
    QUERY_DATE = moment(QUERY_DATE).subtract(this.state.dayLength, 'days').format('YYYY-MM-DD')
    //本地日志
    let localErrLog = JSON.parse(localStorage.getItem('httpErrorLogList')) || []
    let loaclData = []
    let EXAM_UID = this.props.form.getFieldValue("EXAM_UID")
    if (EXAM_UID !== '') {//选了examuid,不按照日期查询
      localErrLog.forEach(item => {
        let arr = item.filter(mitem => mitem.EXAM_UID.includes(EXAM_UID))
        loaclData = [...loaclData, ...arr]
      });
    } else {
      loaclData = localErrLog.find((item) => //查到当天的前端日志
        item[0].DATE.slice(0, 10) === QUERY_DATE//"2024-04-25 15:47:32"'2024-04-25'
      )
      if (loaclData) {
        loaclData = loaclData.length > 1 ? loaclData.reverse() : loaclData
        if (USER_UID !== '') {
          loaclData = loaclData.filter(item => item.USER_UID === USER_UID)
        }
      } else {
        loaclData = []
      }
    }
    let Param = {
      Type: "GetLogData",
      USER_UID: EXAM_UID === '' ? USER_UID : '',//有EXAM_UID其他条件都传空
      EXAM_UID,
      QUERY_DATE: EXAM_UID === '' ? QUERY_DATE : ''
    }
    GetLogData(Param).then((res) => {
      if (res && res.Status === 1) {//请求通
        let sqlData = res.Result
        let currentLogData = []
        currentLogData = this.mergeSortedArrays(Array.isArray(loaclData) ? loaclData : [], Array.isArray(sqlData) ? sqlData : [])
        currentLogData = currentLogData.map((item) => {
          let USERITEM = this.state.allUserList.find(itemU => itemU.USER_UID === item.USER_UID)
          return {
            USER_NAME: USERITEM ? USERITEM.USER_NAME : '未知',
            USER_UID: item.USER_UID,
            EXAM_UID: item.EXAM_UID,
            CONTENT: item.CONTENT,
            DATE: item.DATE,
            FLAG: item.FLAG,//1为错误日志
          }
        })
        this.setState({
          data: [...this.state.data, ...currentLogData],
          loading: false,
          dayLength: this.state.dayLength + 1,
          EXAM_UID
        })
      } else {//请求不通
        loaclData = loaclData.map((item) => {
          let USERITEM = this.state.allUserList.find(itemU => itemU.USER_UID === item.USER_UID)
          return {
            USER_NAME: USERITEM ? USERITEM.USER_NAME : '未知',
            USER_UID: item.USER_UID,
            EXAM_UID: item.EXAM_UID,
            CONTENT: item.CONTENT,
            DATE: item.DATE,
            FLAG: item.FLAG,//1为错误日志
          }
        })
        this.setState({
          data: [...this.state.data, ...loaclData],
          loading: false,
          dayLength: this.state.dayLength + 1,
          EXAM_UID,
        })
      }
    })
  };
  mergeSortedArrays = (arr1, arr2) => {
    let result = [];
    let i = 0, j = 0;
    // 合并两个数组
    while (i < arr1.length && j < arr2.length) {
      if (moment(arr1[i].DATE).isAfter(moment(arr2[j].DATE))) {
        result.push(arr1[i++]);
      } else {
        result.push(arr2[j++]);
      }
    }
    // 将剩余元素添加到结果数组中
    while (i < arr1.length) {
      result.push(arr1[i++]);
    }
    while (j < arr2.length) {
      result.push(arr2[j++]);
    }
    return result;
  }
  listHeaderLayout() {
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ width: 200, textAlign: 'center' }}>操作时间</div>
        <div style={{ width: 100, textAlign: 'center', borderRight: '1px' }}>操作人</div>
        <div style={{ width: 150, textAlign: 'center' }}>病例ID</div>
        <div style={{ width: 1015, textAlign: 'center' }}>日志描述</div>
      </div>
    )
  }
  handleCheckTypeList = () => {
    //查询时，清空已缓存的数据
    this.setState({
      data: [],
      dayLength: 0,
    }, () => {
      this.loadMoreData()
    })
  }
  resetSearchpart = () => {
    this.props.form.resetFields();
  }
  changeFocus = (e) => {
    if (e.keyCode === 13) {
      this.handleCheckTypeList();
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="formWrap" style={{ width: "80%" }}>
        <Divider orientation="left">日志管理</Divider>
        <Form layout="inline" className="searchBox">
          <Form.Item label="病例编码">
            {getFieldDecorator("EXAM_UID", { initialValue: "" })(<Input onKeyUp={this.changeFocus} />)}
          </Form.Item>
          {

            this.state.userInfo.USER_UID === 'PLATFORMUSER' ?
              <>
                <Form.Item label="医院">
                  {getFieldDecorator("HOSPITAL_CODE", { initialValue: "" })(
                    <Select style={{ width: '179px' }}
                      showSearch optionFilterProp="children"
                      onChange={this.changeHosToDept}
                    >
                      {this.state.hosptialList.map((item) => (
                        <Option key={item.HOSPITAL_UID} value={item.HOSPITAL_CODE}>{item.HOSPITAL_NAME}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
                <Form.Item label="操作人员">
                  {getFieldDecorator("USER_UID", { initialValue: "" })(
                    <Select style={{ width: '100px' }}>
                      {/* <Option value="">全部</Option> */}
                      {this.state.userList.map((item) => (
                        <Option key={item.USER_UID} value={item.USER_UID}>{item.USER_NAME}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </> : null
          }
          <Form.Item label="日志时间">
            {getFieldDecorator("logTime", {
              initialValue: moment(this.state.logDate),
            })(
              <DatePicker allowClear={false} />
            )}
          </Form.Item>
          <Button style={{ marginRight: "10px" }} onClick={this.handleCheckTypeList}>查询</Button>
          <Button onClick={this.resetSearchpart}>重置</Button>
        </Form>
        <div
          id="scrollableDiv"
          style={{
            height: 730,
            overflow: 'auto',
            border: '1px solid rgba(140, 140, 140, 0.35)',
            width: 1465
          }}
        >
          <List
            className="logManageList"
            header={
              this.listHeaderLayout()
            }
            dataSource={this.state.data}
            renderItem={(item) => (
              <List.Item key={item.DATA_UID} style={{ color: item.FLAG === 0 ? 'black' : 'red' }}>
                <div style={{ width: 200, textAlign: 'center' }}>{item.DATE ? moment(item.DATE).format('YYYY-MM-DD HH:mm:ss') : '未知'}</div>
                <div style={{ width: 100, textAlign: 'center' }}>{item.USER_NAME ? item.USER_NAME : '未知'}</div>
                <div style={{ width: 150, textAlign: 'center' }}>{item.EXAM_UID ? item.EXAM_UID : '未知'}</div>
                <Tooltip title={'日志描述：' + item.CONTENT} overlayClassName='tooltipStyle'>
                  <div style={{ width: 1015, textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {'日志描述：' + item.CONTENT}
                  </div>
                </Tooltip>
              </List.Item>
            )}
          />
          {
            this.state.loading ? <Skeleton
              avatar
              paragraph={{
                rows: 1,
              }}
              active
            /> : null
          }
          {
            this.state.dayLength === 7 ? <Divider>已加载七日数据，如需更多，请重新选择日志时间 🤐</Divider> : null
          }
          {
            this.state.dayLength < 7 && this.state.EXAM_UID === '' ? <Divider>下拉刷新查询更多信息</Divider> : null
          }
          {
            this.state.EXAM_UID !== '' ? <Divider>根据病例ID查询，已是相关病例的全部信息 🤐</Divider> : null
          }
        </div>
      </div>
    );
  }
}

export default (Form.create({})(SettingDepartment))
